import { isEmpty, range } from 'lodash-es'
import { formatScientific } from '@/utils/formatters'

const rowHasAnyEstimate = (row) => Object.values(row?.predictionsByModelId).some((prediction) => !isEmpty(prediction))

const rowHasAnyError = (row) => Object.values(row?.errorsByModelId).some((error) => !isEmpty(error))

const formatScientificWithBlankEmpty = (value, unit) => formatScientific(value, { blank: '', unit })

const formatRange = (range, unit) => {
  const parseRange = (range) => {
    if (typeof range === 'string') {
      if (range.startsWith('[') && range.endsWith(']')) return range.slice(1, -1).split(':')
    }
    return range
  }
  const parsedRange = parseRange(range)

  if (!parsedRange || !Array.isArray(parsedRange) || parsedRange.length !== 2) return parsedRange
  return parsedRange.map((value) => formatScientificWithBlankEmpty(value, unit)).join(' to ')
}

export { rowHasAnyEstimate, rowHasAnyError, formatScientificWithBlankEmpty, formatRange }
